import { createRef, PureComponent } from 'react';
import classNames from 'classnames/bind';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import loadable from '@utils/loadable';

import { isMobile } from 'react-device-detect';
import setAmount from '../../../../helpers/setAmount';
import withComponentName from '../../../../decorators/withComponentName';
import StorageSvc from '../../../../services/StorageSvc';
import HPService from '../../../../services/HPService';

import WistiaPlayer from '../../../Shared/WistiaPlayer';

import Styles from './styles.module.scss';

const PremiumContentPublications = loadable(() => import('./LearnMoreSections/PremiumContentPublications'));
const TableComponent = loadable(() => import('../TableComponent'));
const GreetingSection = loadable(() => import('./LearnMoreSections/GreetingSection'));
const TrustedSection = loadable(() => import('./LearnMoreSections/TrustedSection'));
const IntegratedNewsSection = loadable(() => import('./LearnMoreSections/IntegratedNewsSection'));
const DueDiligenceSection = loadable(() => import('./LearnMoreSections/DueDiligenceSection'));
const DriveDueDiligenceSection = loadable(() => import('./LearnMoreSections/DriveDueDiligenceSection'));
const FeaturedInSection = loadable(() => import('./LearnMoreSections/FeaturedInSection'));
const CustomCarousel = loadable(() => import('../../../CustomCarousel'));
const NewsCoverage = loadable(() => import('./LearnMoreSections/NewsCoverageSection'));
const DataSecurity = loadable(() => import('./LearnMoreSections/DataSecurity'));
const MembersOfSection = loadable(() => import('./LearnMoreSections/MembersOfSection'));
const ButtonComponent = loadable(() => import('../../../Buttons/ButtonComponent'));
// const ChatBotSection = loadable(() => import('./HomeSections/ChatBotSection'));

const cx = classNames.bind(Styles);

export class LearnMore extends PureComponent {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      width: 0,
      isGuestWatchlists: false,
      isUserWatchlists: false,
      nlpVideoPlay: false,
      fixedTableHead: false,
    };

    this.video = createRef();
    this.secondVideo = createRef();
    this.theadref = createRef();
    this.carouselRef = createRef();
  }

  componentDidMount() {
    const { width } = this.state;

    const { token } = this.props;
    window.addEventListener('orientationchange', this.onOrientationChange);
    window.addEventListener('resize', this.resizeHandle, { passive: true });
    document.addEventListener('scroll', this.scrollTableHandler, { passive: true });
    if (width <= 767) document.addEventListener('scroll', this.scrollHandler, { passive: true });

    this.checkGuestUserWl();
    if (token) {
      this.setState({
        isUserWatchlists: HPService.isWatchListPresent(),
      });
    }
    this.setWidth();

    document.body.style.height = 'auto';
  }

  componentWillUnmount() {
    const { width } = this.state;
    window.removeEventListener('resize', this.resizeHandle);
    window.removeEventListener('orientationchange', this.onOrientationChange);
    document.removeEventListener('scroll', this.scrollTableHandler);
    if (width <= 767) document.removeEventListener('scroll', this.scrollHandler);

    document.body.style.removeProperty('height');
  }

  onOrientationChange() {
    const { nlpVideoPlay, startVideoPlay } = this.state;
    setTimeout(() => {
      if (nlpVideoPlay) {
        this.video.current.scrollIntoView({ block: 'center' });
      }
      if (startVideoPlay) {
        this.secondVideo.current.scrollIntoView({ block: 'center' });
      }
    }, 300);
  }

  setElement(el) {
    if (el) {
      this.layoutEl = el;
      setTimeout(this.setWidth, 0);
    }
  }

  setWidthLine(defaultWidth) {
    const { width } = this.state;
    const diff = 1280 - width;

    if (defaultWidth < 0) return -(-defaultWidth - diff / 2);
    return defaultWidth - diff / 2;
  }

  setWidth() {
    if (this.layoutEl) {
      this.setState({ width: this.layoutEl.offsetWidth });
    }
  }

  scrollHandler() {
    const { scrolled } = this.state;

    if (!scrolled && window.pageYOffset > 450) {
      this.setState({
        scrolled: true,
      });
    }
    if (scrolled && window.pageYOffset <= 450) {
      this.setState({
        scrolled: false,
      });
    }
  }

  scrollTableHandler() {
    if (this.theadref.current) {
      const tablePosition = this.theadref.current.getBoundingClientRect();

      this.setState({
        fixedTableHead: tablePosition.top < 75 && (tablePosition.height + tablePosition.top) > 180,
      });
    }
    if (this.carouselRef.current) {
      const carouselPosition = this.carouselRef.current
        .sliderWrapper.current.getBoundingClientRect();
      if (carouselPosition.top > 750 || carouselPosition.top < -750) {
        this.carouselRef.current.setState({ activeTab: '' });
        this.carouselRef.current.setState({ activeTab: 'desktop' });
      } else {
        this.setState({ startVideoPlay: false, nlpVideoPlay: false });
      }
    }
  }

  resizeHandle() {
    this.setWidth();
  }

  checkGuestUserWl() {
    this.setState({ isGuestWatchlists: StorageSvc.getItem('watchlist') !== null });
  }

  sendHomePageActions(action) {
    const { piwikEnabled } = this.props;

    if (piwikEnabled) _paq.push(['trackEvent', 'Home page', action]);
  }

  startVideo() {
    const { piwikEnabled } = this.props;

    if (piwikEnabled) _paq.push(['trackEvent', 'Home page', 'Vision video play']);
  }

  trackNlpVideo() {
    const { piwikEnabled } = this.props;

    if (piwikEnabled) _paq.push(['trackEvent', 'Home page', 'NLP video play']);
  }

  pauseNlpVideo() {
    this.setState({ nlpVideoPlay: false });
  }

  playNlpVideo() {
    this.setState({ nlpVideoPlay: true, startVideoPlay: false });
  }

  playStartVideo() {
    this.setState({ startVideoPlay: true, nlpVideoPlay: false });
  }

  pauseStartVideo() {
    this.setState({ startVideoPlay: false });
  }

  render() {
    const {
      windowWidth,
      searchBarActive, piwikEnabled,
      user, cookiesPolicyStatus,
    } = this.props;
    const {
      isGuestWatchlists,
      width, nlpVideoPlay,
      startVideoPlay, scrolled,
      fixedTableHead,
      isUserWatchlists,

    } = this.state;

    const offset = windowWidth - width;

    const centerForLine = (windowWidth - offset) / 2;

    const mainHomeClass = cx('main-home', {
      homepage_blured: searchBarActive,
      scrolled,
    });

    return (
      <div className={mainHomeClass}>
        { searchBarActive && <div className={Styles.overlay} /> }
        <section className={Styles.greeting_section}>
          <GreetingSection
            isGuestWatchlists={isGuestWatchlists}
            isWatchlists={isUserWatchlists}
            sendHomePageActions={this.sendHomePageActions}
          />
        </section>

        <TrustedSection />

        <>
          <DriveDueDiligenceSection
            user={user}
            windowWidth={windowWidth}
            ref={this.carouselRef}
          />

          <DueDiligenceSection />

          <PremiumContentPublications />

          <NewsCoverage
            sendHomePageActions={this.sendHomePageActions}
          />

          <section className={Styles.NLP_video_section}>
            <div className={Styles['nlp-video-title']}>
              <h1 className={Styles.title}>HOW WE DO IT</h1>
              <p className={Styles.institutions}>
                Leverage AI, Natural Language Processing (NLP), and Machine Learning (ML)
              </p>
            </div>
            <div
              className={Styles['nlp-video-wrapper']}
              ref={this.video}
            >
              <WistiaPlayer
                url="https://cityfalcon.wistia.com/medias/3s8nuthz6f"
                style={{
                  width: '100%',
                  height: '100%',
                }}
                onStart={this.trackNlpVideo}
                onPlay={this.playNlpVideo}
                playing={nlpVideoPlay}
                onPause={this.pauseNlpVideo}
                controls
                config={{
                  options: isMobile ? { playsinline: false } : {},
                }}
              />
            </div>
          </section>

          {/* chatbot was hidden */}
          {/* <ChatBotSection /> */}

          <IntegratedNewsSection
            windowWidth={windowWidth}
            centerForLine={centerForLine}
            sendHomePageActions={this.sendHomePageActions}
            width={width}
          />

          <section className={Styles.why_is_better}>
            <div className={Styles.table_container}>
              <TableComponent
                ref={this.theadref}
                fixedTableHead={fixedTableHead}
              />
            </div>
          </section>

          <DataSecurity />

          <section className={Styles['advertisement-section']}>
            <FeaturedInSection
              windowWidth={windowWidth}
            />
            <MembersOfSection
              windowWidth={windowWidth}
            />
          </section>

          <section
            className={Styles.testimonials}
          >
            <div className={Styles.description}>
              <h1 className={`${Styles.title} text-uppercase`}>
                What our customers say about us
              </h1>
              <p className={Styles.institutions}>
                <a href="/contact-us">Send us your own</a>
                &nbsp;for a chance to be seen on our front page
              </p>
            </div>
            <div className={Styles.tweets_container}>
              <CustomCarousel
                width={windowWidth}
                amountInSlide={setAmount(windowWidth, 3, 1, 1)}
                section="testimonials"
                url="testimonial_tweets"
              />
            </div>
          </section>

          <section className={Styles.just_start}>
            <div
              className={Styles.just_start_section}
              ref={this.setElement}
            >
              <div className={Styles.vision}>
                <h3 className={`${Styles.title} text-uppercase`}>This is just the start</h3>
                <h5 className={Styles.institutions}>
                  Explore our long-term vision in the video
                </h5>
              </div>
              <div
                className={Styles.start_video}
                ref={this.secondVideo}
              >
                <WistiaPlayer
                  url="https://cityfalcon.wistia.com/medias/1cyold2f7s"
                  onStart={this.startVideo}
                  playing={startVideoPlay}
                  onPlay={this.playStartVideo}
                  onPause={this.pauseStartVideo}
                  config={{
                    options: isMobile ? { playsinline: false } : {},
                  }}
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                />
              </div>
            </div>
          </section>
          <div className={cx('mobile-get-started-block', { cookies_policy: cookiesPolicyStatus })}>
            <div className={Styles.get_started_button_container}>
              <ButtonComponent
                withoutReload
                value="Get Started"
                short
                green
                path="/news/onboarding/watchlist"
              />
            </div>
          </div>
        </>
      </div>
    );
  }
}

const mapStateToProps = ({ common, searchReducers, watchlistReducer }) => ({
  searchBarActive: searchReducers.searchBarActive,
  windowWidth: common.width,
  cookiesPolicyStatus: common.cookiesPolicyStatus,
  token: watchlistReducer.userToken,
});

export default withComponentName(connect(mapStateToProps)(LearnMore));
